import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        /**
         * 是否需要全屏
         */
        isFullscreen: false
    },
    mutations: {
        update(state, [key, value]) {
            state[key] = value;
        },
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js